import { baseApi } from "./api";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const BUSINESS_ROUTES = {
  BUSINESS_DATA: "/business/",
  BUSINESS_PICTURE: "/business/picture/",
  PERMISSION_LEVEL: "/business/staffs/permission-level",
};

const businessApi = {
  getBusinessData: async () => {
    const response = await baseApi.get(BUSINESS_ROUTES.BUSINESS_DATA);
    return response;
  },
  updateBusinessData: async (data: any) => {
    const response = await baseApi.put(BUSINESS_ROUTES.BUSINESS_DATA, data);
    return response;
  },
  updateBusinessPicture: async (data: any) => {
    const response = await baseApi.put(BUSINESS_ROUTES.BUSINESS_PICTURE, data);
    return response;
  },
  getPermissionLevel: async () => {
    const response = await baseApi.get(BUSINESS_ROUTES.PERMISSION_LEVEL);
    return response;
  },
};

// React Query hooks
export function useBusinessData() {
  return useQuery({
    queryKey: ["businessData"],
    queryFn: businessApi.getBusinessData,
  });
}

export function useUpdateBusinessData() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: businessApi.updateBusinessData,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["businessData"] });
    },
  });
}

export function useUpdateBusinessPicture() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: businessApi.updateBusinessPicture,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["businessData"] });
    },
  });
}

export { businessApi };
